import { Map, List } from 'immutable';

import { practiceEfectoresActions } from './actions';
import { PracticeEfectors  } from './practice-efectores';
import { DEFAULT_SESSION_ID } from '../constants';


export const initialState = new Map({
  currentPracticeEfectoresId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new PracticeEfectors({id: DEFAULT_SESSION_ID, isNew: false})
});

export function practicesEfectoresReducer(state = initialState, action) {
  const { payload, type } = action

  switch (type) {

    case practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_FAILED:
    case practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_FAILED:
    case practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_SUCCESS:
    case practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_SUCCESS:
    case practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_PENDING:
    case practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_SUCCESS:
      return state.set(
        payload.practiceEfectoresId,
        practiceEfectoresReducer(state.get(payload.practiceEfectoresId), action)
      );
    case practiceEfectoresActions.LOAD_PRACTICE_EFECTORES:
      return state.merge({
        currentPracticeEfectoresId: payload.practiceEfectoresId,
        [payload.practiceEfectoresId]: practiceEfectoresReducer(state.get(payload.practiceEfectoresId), action)
      });
    default:
      return state;
  }
}

export const practiceEfectoresReducer = (state = new PracticeEfectors() , { payload, type }  ) => {
  switch (type) {
    case practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_FAILED:
    case practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_FAILED:      
      alert(payload.error.message)
      return state.set('isPending', false);
    case practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_SUCCESS:
      return state.withMutations(practiceEfectors => {
          practiceEfectors.merge({
            isNew: false,
            isPending: false,
            items: new List(payload.data),
            total: payload.data.length,
          });
      });
      case practiceEfectoresActions.DELETE_PRACTICE_EFECTORES_SUCCESS:
        return state.withMutations(practiceEfectors => {
            const total = practiceEfectors.total-1;
            practiceEfectors.merge({
              items: practiceEfectors.items.slice(0, total),
              total,
              isPending: false,
            });
        });
    case practiceEfectoresActions.UPDATE_PRACTICE_EFECTORES_SUCCESS:
      return state.set('isPending', false);
    case practiceEfectoresActions.FETCH_PRACTICE_EFECTORES_PENDING:
      return state.set('isPending', true);
    case practiceEfectoresActions.LOAD_PRACTICE_EFECTORES:
      return state.merge({
            id: payload.practiceEfectoresId,
            filters: payload.filters,
        });
    default:
      return state;
  }
}
